import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, throwError} from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router: Router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      if ([401, 419].includes(error.status)) {
        router.navigate(['/auth/login']);
      }
      // if (error.status === 419 && !isRetry) {
      //   return authService.csrf().pipe(
      //     switchMap(() => {
      //       const retryReq = req.clone({
      //         headers: req.headers.set('X-Retry-Request', 'true')
      //       });

      //       return next(retryReq);
      //     }),
      //     catchError((retryError: HttpErrorResponse) => {
      //       if ([401, 419].includes(retryError.status)) {
      //         router.navigate(['/auth/login']);
      //       }
      //       return throwError(() => retryError);
      //     })
      //   );
      // }

      // if ([401, 419].includes(error.status)) {
      //   router.navigate(['/auth/login']);
      // }

      return throwError(() => error);
    })
  );
};
